module.exports = __webpack_public_path__ + "img/bgResignationApproval.47bc5c61.png";